import classNames from 'clsx';
import he from 'he';
import React from 'react';

import Link from '@swf/components/Link/Link';
import Arrow from '@swf/core/assets/icons/arrow.svg';
import { RoutingKey } from '@swf/core/enums';
import type { Article } from '@swf/help';

import styles from './ArticleList.scss';

export interface Props {
  articles?: Article[];
  column?: number;
  highlight?: boolean;
  listOnMobile?: boolean;
  regularHeight?: boolean;
}

const ArticleList: React.FC<Props> = ({
  articles,
  column = 1,
  highlight,
  listOnMobile,
  regularHeight
}) => (
  <ul
    className={column === 2 ? styles.columns : highlight ? styles.highlightColumn : styles.column}
    data-testid="article-list"
  >
    {articles?.map(({ id, ref, title }) => (
      <li
        key={id}
        className={classNames(
          { [styles.article]: !highlight && !listOnMobile },
          { [styles.highlight]: highlight },
          { [styles.articleList]: listOnMobile },
          { [styles.regularHeight]: regularHeight }
        )}
        data-testid={`article-list-${id}`}
      >
        <Link route={RoutingKey.HelpCenterArticle} values={{ ref }}>
          <span className={highlight || listOnMobile ? styles.noWrapTitle : styles.title}>
            {he.decode(title)}
          </span>
          <Arrow className={styles.arrow} width={12} height={12} />
        </Link>
      </li>
    ))}
  </ul>
);

export default ArticleList;
